import {Injectable} from "@angular/core";
import {EmployeeCostDto} from "../../../../../../models/employee-cost-dto";

@Injectable({
  providedIn: 'root'
})
export class EmploymentCostsRepository {
  employeeCosts: EmployeeCostDto[] = [];
  totalEmployeeCosts: number = 0;
  totalEmployeeHours: number = 0;

  constructor() {
  }

  initialize(employeeCostsDto: EmployeeCostDto[]) {
    this.employeeCosts = employeeCostsDto;
    this.totalEmployeeCosts = this.calculateEmployeeCosts(this.employeeCosts);
    this.totalEmployeeHours = this.calculateEmployeeHours(this.employeeCosts);
  }

  calculateEmployeeCosts(employeeCosts: EmployeeCostDto[]) {
    // sum of all employee costs
    return employeeCosts.reduce((acc, employeeCost) => acc + (employeeCost.salary * employeeCost.workingHours) + employeeCost.salaryAdditions, 0);
  }

  calculateEmployeeHours(employeeCosts: EmployeeCostDto[]) {
    return employeeCosts.reduce((acc, employeeCosts) => acc + employeeCosts.workingHours, 0);
  }

  getTotalEmployeeCosts() {
    return this.totalEmployeeCosts;
  }

  getTotalEmployeeHours() {
    return this.totalEmployeeHours;
  }
}


